
import React,{ useContext, useEffect } from 'react';
import {  BrowserRouter as Router, Link, Route,  Switch } from 'react-router-dom';
import './App.css';
import AdminLogIn from './Components/Admin/AdminLogIn';
import AdminRouter from './Components/Admin/AdminRouter';
import { firebaseAuth } from './Components/Admin/AuthProvider';


import Konferencija from './Components/Home/Konferencija';
import PrijavaPredavac from './Components/Home/PrijavaPredavac';



function App() {
  const {token} = useContext(firebaseAuth)
 

  function TokenValidation(){

    if(token===null){
      return <AdminLogIn/>
    }
    return <AdminRouter/>
  }

  return (

    <Router>
        <Switch>     
          <Route exact path="/" component={Konferencija}/>
          <Route exact path="/prijave" component={PrijavaPredavac}/>

          <Route  path='/admin' component={TokenValidation} />

       </Switch>

    </Router>
   
  );
}

export default App;
